export default "__VITE_ASSET__ZxYlDlWE__"